import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={true} />
      
      <div className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-[#0A381F] mb-4">Cookie Policy</h1>
            <p className="text-gray-600 text-lg">Last updated: January 2025</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">1. What Are Cookies?</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Cookies are small text files that are placed on your device (computer, smartphone, or tablet) when you visit a website. 
                They are widely used to make websites work more efficiently and provide information to website owners.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Cookies help us understand how you use our platform, remember your preferences, and improve your overall experience.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">2. Types of Cookies We Use</h2>
              
              <div className="space-y-8">
                <div className="bg-gray-50 border-l-4 border-[#D4AF37] p-6 rounded-r-lg">
                  <h3 className="text-2xl font-bold text-[#0A381F] mb-3">Strictly Necessary Cookies</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    These cookies are essential for the website to function properly. They enable core functionality such as security, 
                    network management, and accessibility. Without these cookies, services you have requested cannot be provided.
                  </p>
                  <p className="text-sm text-gray-600 mb-2"><strong>Examples:</strong></p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-600">
                    <li>Authentication cookies (keep you logged in)</li>
                    <li>Security cookies (prevent fraud and abuse)</li>
                    <li>Session cookies (maintain your session state)</li>
                  </ul>
                  <p className="text-sm font-semibold text-[#0A381F] mt-4">Status: Always Active (Cannot be disabled)</p>
                </div>

                <div className="bg-gray-50 border-l-4 border-teal-500 p-6 rounded-r-lg">
                  <h3 className="text-2xl font-bold text-[#0A381F] mb-3">Functional Cookies</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    These cookies enable enhanced functionality and personalization. They may be set by us or by third-party providers 
                    whose services we have added to our pages.
                  </p>
                  <p className="text-sm text-gray-600 mb-2"><strong>Examples:</strong></p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-600">
                    <li>Language preferences</li>
                    <li>Region selection</li>
                    <li>User interface customization</li>
                    <li>Video player settings</li>
                  </ul>
                  <p className="text-sm font-semibold text-[#0A381F] mt-4">Status: Optional (Can be disabled)</p>
                </div>

                <div className="bg-gray-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                  <h3 className="text-2xl font-bold text-[#0A381F] mb-3">Analytics Cookies</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. 
                    This helps us improve our services and user experience.
                  </p>
                  <p className="text-sm text-gray-600 mb-2"><strong>Examples:</strong></p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-600">
                    <li>Google Analytics (traffic analysis)</li>
                    <li>Page view tracking</li>
                    <li>User behavior patterns</li>
                    <li>Performance metrics</li>
                  </ul>
                  <p className="text-sm font-semibold text-[#0A381F] mt-4">Status: Optional (Can be disabled)</p>
                </div>

                <div className="bg-gray-50 border-l-4 border-purple-500 p-6 rounded-r-lg">
                  <h3 className="text-2xl font-bold text-[#0A381F] mb-3">Marketing Cookies</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    These cookies are used to track visitors across websites to display relevant advertisements. 
                    They help us measure the effectiveness of our marketing campaigns and deliver personalized content.
                  </p>
                  <p className="text-sm text-gray-600 mb-2"><strong>Examples:</strong></p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-600">
                    <li>Advertising network cookies</li>
                    <li>Social media tracking pixels</li>
                    <li>Retargeting cookies</li>
                    <li>Conversion tracking</li>
                  </ul>
                  <p className="text-sm font-semibold text-[#0A381F] mt-4">Status: Optional (Can be disabled)</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">3. First-Party vs. Third-Party Cookies</h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-[#0A381F] mb-3">First-Party Cookies</h3>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">
                    Set directly by MoveToIreland.us. These cookies are used to provide core functionality and improve your experience on our platform.
                  </p>
                  <p className="text-xs text-gray-600"><strong>Domain:</strong> movetoireland.us</p>
                </div>

                <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
                  <h3 className="text-xl font-bold text-[#0A381F] mb-3">Third-Party Cookies</h3>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4">
                    Set by external services we use, such as analytics providers, payment processors, and social media platforms.
                  </p>
                  <p className="text-xs text-gray-600"><strong>Examples:</strong> Google, Stripe, Facebook</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">4. Specific Cookies We Use</h2>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-[#0A381F] text-white">
                      <th className="border border-gray-300 px-4 py-3 text-left">Cookie Name</th>
                      <th className="border border-gray-300 px-4 py-3 text-left">Type</th>
                      <th className="border border-gray-300 px-4 py-3 text-left">Purpose</th>
                      <th className="border border-gray-300 px-4 py-3 text-left">Duration</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">session_id</td>
                      <td className="border border-gray-300 px-4 py-3">Necessary</td>
                      <td className="border border-gray-300 px-4 py-3">Maintains user session</td>
                      <td className="border border-gray-300 px-4 py-3">Session</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">auth_token</td>
                      <td className="border border-gray-300 px-4 py-3">Necessary</td>
                      <td className="border border-gray-300 px-4 py-3">User authentication</td>
                      <td className="border border-gray-300 px-4 py-3">30 days</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">cookie_consent</td>
                      <td className="border border-gray-300 px-4 py-3">Necessary</td>
                      <td className="border border-gray-300 px-4 py-3">Stores cookie preferences</td>
                      <td className="border border-gray-300 px-4 py-3">1 year</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">language</td>
                      <td className="border border-gray-300 px-4 py-3">Functional</td>
                      <td className="border border-gray-300 px-4 py-3">Remembers language preference</td>
                      <td className="border border-gray-300 px-4 py-3">1 year</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">_ga</td>
                      <td className="border border-gray-300 px-4 py-3">Analytics</td>
                      <td className="border border-gray-300 px-4 py-3">Google Analytics tracking</td>
                      <td className="border border-gray-300 px-4 py-3">2 years</td>
                    </tr>
                    <tr className="bg-gray-50">
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">_gid</td>
                      <td className="border border-gray-300 px-4 py-3">Analytics</td>
                      <td className="border border-gray-300 px-4 py-3">Google Analytics session</td>
                      <td className="border border-gray-300 px-4 py-3">24 hours</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 font-mono text-xs">_fbp</td>
                      <td className="border border-gray-300 px-4 py-3">Marketing</td>
                      <td className="border border-gray-300 px-4 py-3">Facebook Pixel tracking</td>
                      <td className="border border-gray-300 px-4 py-3">3 months</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">5. How to Manage Cookies</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">5.1 Cookie Consent Banner</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                When you first visit our website, you'll see a cookie consent banner. You can:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li><strong>Accept All:</strong> Allow all cookies for the best experience</li>
                <li><strong>Reject All:</strong> Only necessary cookies will be used</li>
                <li><strong>Customize:</strong> Choose which cookie categories to allow</li>
              </ul>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">5.2 Browser Settings</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Most web browsers allow you to control cookies through their settings. You can:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Block all cookies</li>
                <li>Block third-party cookies only</li>
                <li>Delete cookies after each session</li>
                <li>View and delete existing cookies</li>
              </ul>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg mt-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-alert-line text-yellow-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-yellow-900 mb-2">Important Note</h4>
                    <p className="text-yellow-800 text-sm leading-relaxed">
                      Blocking or deleting cookies may impact your experience on our platform. Some features may not work properly, 
                      and you may need to re-enter information or preferences.
                    </p>
                  </div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-8">5.3 Browser-Specific Instructions</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <a 
                  href="https://support.google.com/chrome/answer/95647" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-[#D4AF37] transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                    <i className="ri-chrome-fill text-2xl text-gray-700"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-[#0A381F]">Google Chrome</p>
                    <p className="text-xs text-gray-600">Manage cookies</p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-external-link-line text-gray-400"></i>
                  </div>
                </a>

                <a 
                  href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-[#D4AF37] transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                    <i className="ri-firefox-fill text-2xl text-gray-700"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-[#0A381F]">Mozilla Firefox</p>
                    <p className="text-xs text-gray-600">Manage cookies</p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-external-link-line text-gray-400"></i>
                  </div>
                </a>

                <a 
                  href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-[#D4AF37] transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                    <i className="ri-safari-fill text-2xl text-gray-700"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-[#0A381F]">Safari</p>
                    <p className="text-xs text-gray-600">Manage cookies</p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-external-link-line text-gray-400"></i>
                  </div>
                </a>

                <a 
                  href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-[#D4AF37] transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg">
                    <i className="ri-edge-fill text-2xl text-gray-700"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-[#0A381F]">Microsoft Edge</p>
                    <p className="text-xs text-gray-600">Manage cookies</p>
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-external-link-line text-gray-400"></i>
                  </div>
                </a>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">6. Third-Party Cookie Policies</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We use services from third-party providers who may set their own cookies. Please review their cookie policies:
              </p>
              <ul className="space-y-2">
                <li>
                  <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer">
                    Google Analytics Cookie Policy
                  </a>
                </li>
                <li>
                  <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer" className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer">
                    Stripe Cookie Policy
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noopener noreferrer" className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer">
                    Facebook Cookie Policy
                  </a>
                </li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">7. Updates to This Policy</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We may update this Cookie Policy from time to time to reflect changes in our practices or legal requirements. 
                We will notify you of significant changes by posting the updated policy with a new "Last Updated" date.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">8. Contact Us</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If you have questions about our use of cookies, please contact us:
              </p>
              <div className="bg-[#0A381F] text-white rounded-xl p-8">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-bold mb-2 flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-mail-line text-xl"></i>
                      </div>
                      Email
                    </h4>
                    <p className="text-white/80">privacy@movetoireland.us</p>
                  </div>
                  <div>
                    <h4 className="font-bold mb-2 flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-map-pin-line text-xl"></i>
                      </div>
                      Address
                    </h4>
                    <p className="text-white/80">[Your Business Address]</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex flex-wrap gap-4 justify-center">
              <Link 
                to="/privacy" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link 
                to="/terms" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Terms of Service
              </Link>
              <span className="text-gray-400">•</span>
              <Link 
                to="/" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
